module.exports = __webpack_public_path__ + "img/gift_info_01.15bfeaf2.png";